<template>
    <div :hidden="!productSet" v-if="modalReady">
        <div class="modal fade" id="moa-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-fixed" role="document">
               <div class="modal-content">
                    <div class="modal-header text-center">
                        <h5 class="modal-title mr-1" v-html="modalTitle"></h5>

                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true"><img src="img/ui-elements/close-img.png" alt="Close" /></span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>
                            <strong>Class</strong><br>
                            <span v-html="modalContent.field_moa_class[0].value"></span>
                        </p>

                        <span v-html="modalContent.field_moa_text[0].value"></span>
                        <br/>
                        <img v-if="modalContent.field_moa_image[0]" :src="modalContent.field_moa_image[0].url" :alt="modalContent.field_moa_image[0].alt" />

                        <footer class="footer-references" v-if="modalContent.field_moa_reference[0]">
                            <p v-html="modalContent.field_moa_reference[0].value"></p>
                        </footer>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MoaModal",
        props: ['product'],
        computed: {
            productSet: function () {
                return this.productInfo !== false;
            },
            modalContent: function () {
                return this.productInfo;
            },
            productProp: function () {
                return this.product;
            },
            productTriangle: function() {
                let products = this.$store.getters.getProductNames;
                let filtered = products.filter(el => el.title[0].value.toLowerCase() === this.product.toLowerCase());
                let triangle = '';

                if (filtered.length > 0 && filtered[0].field_black_triangle_for_product.length > 0) {
                    triangle = filtered[0].field_black_triangle_for_product[0].value;
                }

                return triangle;
            },
            modalTitle: function() {
                return `${this.modalContent.title[0].value}${this.productTriangle}`;
            },
        },
        created: function() {

        },
        updated: function() {

        },
        watch: {
            modalContent: function () {
                if(this.modalContent !== false) {
                    this.modalReady = true;
                }
            },
            product: function() {
                if (this.product !== false) {
                    this.getModalData()
                    this.modalReady = true;
                } else {
                    this.modalReady = false;
                    this.productInfo = false;
                }
            }
        },
        mounted: function () {

            this.getModalData();
        },
        data: function () {
            return {
                productInfo: false,
                modalReady: false,
            }
        },
        methods: {
            getProductData: function () {
                let products = this.$store.getters.getProductNames;
                let filtered = products.filter(el => el.title[0].value.toLowerCase() === this.product.toLowerCase() );
                return filtered[0];
            },
            getModalData: function () {

                if(this.product === false || this.product == '')
                {
                    if(this.$route.params.filtertype == 'product') {
                        this.product = this.$route.params.filtervalue;
                    }
                }

                if(this.product !== false && this.product !== '') {
                    this.productInfo = this.getProductData();
                    console.log(this.productInfo);
                }

            }
        }
    }
</script>

<style scoped>

    #moa-modal {
        animation: none;
    }

    .button-span {
        padding: 0 8px;
    }

    .footer-references {
        color: inherit;
        bottom: unset;
    }


</style>